import classes from './Header.module.scss';
import LinkButton, { LinkButtonVariant } from '../LinkButton/LinkButton';
import { Link } from 'react-router-dom';
import CapellaLogo from '../../assets/SvgFiles/capella_logo_rgb.svg';
import React, { useEffect } from 'react';
import Login from '../Login/Login';
import HealthStatus from '../healthstatus/healthstatus';

function Header() {
  return (
    <header className={classes.header}>
      <Link to={'/'} className={classes.logo} aria-label={'Capella Home Page'}>
        <img src={CapellaLogo} alt={''} width="200px" />
      </Link>
      <nav aria-label={'Navigation Links'} className={classes.nav}>
        <LinkButton
          to={'/health-status'}
          icon={'heart'}
          variant={LinkButtonVariant.Plain}
        >
          Health Status
        </LinkButton>
        <LinkButton
          to={'/configmanager'}
          icon={'cog'}
          variant={LinkButtonVariant.Plain}
        >
          Config Manager
        </LinkButton>
        <LinkButton
          to={'/blueprints'}
          icon={'boxes-stacked'}
          variant={LinkButtonVariant.Plain}
        >
          Blueprints
        </LinkButton>
        <LinkButton
          icon={'question-circle'}
          to={'/documentation'}
          variant={LinkButtonVariant.Plain}
        >
          Documentation
        </LinkButton>
        <LinkButton
          icon={'info-circle'}
          to={'https://github.com/Maersk-Global/capella-support/discussions'}
          variant={LinkButtonVariant.Plain}
          external={true}
        >
          Support
        </LinkButton>
        <Login />
      </nav>
    </header>
  );
}

export default Header;
